/* post-t7-1, Bloque J (#564): LA PANTALLA DE BIENVENIDA DE LA APP.

   ARCHIVO EN ASCII A PROPOSITO. Sale SOLO en el paquete de la app, sin sesion, en un telefono que nunca tuvo sesion
   (`hasSignedInBefore`) ni invitado (`hadGuestBefore`). No es una ruta: la pinta el guardia de sesion en lugar de
   su redireccion a "Crea tu cuenta", asi que el gesto de atras desde "Iniciar sesion" la vuelve a mostrar. Cubre la
   pantalla entera (por encima del carril de paginas y de la barra de abajo, sin tocarlos), con el fondo de la
   pantalla de arranque (#111111) para que no haya parpadeo. Diseno cerrado (J2): las medidas van en linea. */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import logo from '../assets/branding/logo-rounded-1024.png';
import { useAuth } from '../contexts/AuthContext';
import { useReadyTranslation } from '../hooks/useReadyTranslation';
import { useNetworkStatus } from '../hooks/useNetworkStatus';
import { ensureNetworkForAuthAction } from '../lib/offline/networkVerdict';
import { trackEvent } from '../lib/analytics';
import { BOOT_BACKGROUND } from './BootSplash';

const NARANJA = '#FF6B00';
const BOTON = { width: '100%', height: 52, borderRadius: 14, fontSize: 16, fontWeight: 600 };

function altoDeLaPantalla() {
  try { return window.innerHeight || 800; } catch { return 800; }
}

export default function BienvenidaApp() {
  const { t, ready } = useReadyTranslation(['auth', 'common']);
  const { loginAsGuest } = useAuth();
  const navigate = useNavigate();
  const net = useNetworkStatus();
  const [alto, setAlto] = useState(altoDeLaPantalla);
  const [creando, setCreando] = useState(false);

  useEffect(() => { trackEvent('welcome_viewed'); }, []);
  useEffect(() => {
    const medir = () => setAlto(altoDeLaPantalla());
    window.addEventListener('resize', medir);
    return () => window.removeEventListener('resize', medir);
  }, []);

  const probar = async () => {
    if (creando) return;
    trackEvent('welcome_guest');
    const gate = ensureNetworkForAuthAction(net.isOffline);
    if (gate !== true && !(await gate)) {
      toast.error(t('auth:login.toasts.no_connection'));
      return;
    }
    setCreando(true);
    try {
      await loginAsGuest();
      navigate('/dashboard', { replace: true });
    } catch (err) {
      toast.error(err?.response?.status === 429 ? t('common:toasts.guest_rate_limit') : t('common:toasts.guest_session_failed'));
      setCreando(false);
    }
  };

  const icono = alto < 600 ? 72 : 96;
  return (
    <div data-testid="bienvenida-app"
      style={{ position: 'fixed', inset: 0, zIndex: 90, backgroundColor: BOOT_BACKGROUND, display: 'flex',
        justifyContent: 'center', overflow: 'hidden', paddingTop: 'env(safe-area-inset-top)' }}>
      <div style={{ width: '100%', maxWidth: 420, display: 'flex', flexDirection: 'column', height: '100%' }}>
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          paddingLeft: 24, paddingRight: 24, minHeight: 0 }}>
          <img src={logo} alt="" data-testid="bienvenida-icono" style={{ width: icono, height: icono }} />
          <p className="font-['Space_Grotesk']" data-testid="bienvenida-marca"
            style={{ marginTop: 20, fontSize: 34, fontWeight: 700, color: '#ffffff', lineHeight: 1.1 }}>
            Quiz<span style={{ color: NARANJA }}>essa</span>
          </p>
          {ready && (
            <p data-testid="bienvenida-frase"
              style={{ marginTop: 10, fontSize: 16, color: '#a0a0a0', textAlign: 'center', maxWidth: 280 }}>
              {t('auth:bienvenida.frase')}
            </p>
          )}
        </div>
        {ready && (
          <div style={{ paddingLeft: 24, paddingRight: 24,
            paddingBottom: 'max(24px, calc(env(safe-area-inset-bottom) + 16px))' }}>
            <button type="button" data-testid="bienvenida-entrar"
              onClick={() => { trackEvent('welcome_login'); navigate('/login'); }}
              style={{ ...BOTON, backgroundColor: NARANJA, color: '#ffffff', border: 'none' }}>
              {t('common:nav.log_in')}
            </button>
            <button type="button" data-testid="bienvenida-crear"
              onClick={() => { trackEvent('welcome_signup'); navigate('/signup'); }}
              style={{ ...BOTON, marginTop: 12, backgroundColor: '#1a1a1a', color: NARANJA,
                border: '1px solid rgba(255, 107, 0, 0.4)' }}>
              {t('common:nav.create_account')}
            </button>
            <button type="button" data-testid="bienvenida-probar" onClick={probar} disabled={creando}
              style={{ display: 'block', width: '100%', minHeight: 44, marginTop: 8, background: 'none', border: 'none',
                fontSize: 14, color: '#a0a0a0', textDecoration: 'underline', opacity: creando ? 0.5 : 1 }}>
              {t('auth:bienvenida.probar')}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
